import closeIcon from "assets/Icon-16-close.svg";

const ErrorInContext = ({onCloseCallback, title = null, text = null, more = null}: {
    onCloseCallback?: () => void,
    title?: string | null;
    text?: string | null,
    more?: string | null;
}) => {
    return (
        <div className="alert alert-warning" role="alert">
            <span className={"img-area-48 top-0 right-0 p-4 position-absolute  cursor-pointer"}>
            <img className={"close-icon"}
                 role="button"
                 src={closeIcon}
                 alt={"close"}
                 data-testid={"__tst_error_in_context_close"}
                 onClick={onCloseCallback}/>
            </span>
            <h2>{title}</h2>
            <div>{text}</div>
            <div className={"mt-16"}>{more}</div>
        </div>
    );
};
export default ErrorInContext;